
$(document).ready(function () {

    function disable_scroll_mobile() {
        window.addEventListener('touchmove', wheel, { passive: false });
    }
    function enable_scroll_mobile() {
        window.removeEventListener('touchmove', wheel, { passive: false });
    }
    // var keys = [32, 33, 34, 35, 36, 37, 38, 39, 40];
    var keys = [33, 34, 35, 36];
    function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault)
            e.preventDefault();
        e.returnValue = false;
    }
    function keydown(e) {
        for (var i = keys.length; i--;) {
            if (e.keyCode === keys[i]) {
                preventDefault(e);
                return;
            }
        }
    }
    function wheel(e) {
        preventDefault(e);
    }
    function disable_scroll() {
        if (window.addEventListener) {
            window.addEventListener('DOMMouseScroll', wheel);
        }
        window.addEventListener('mousewheel', wheel, { passive: false });
        document.onkeydown = keydown;
        disable_scroll_mobile();
    }
    function enable_scroll() {
        if (window.removeEventListener) {
            window.removeEventListener('DOMMouseScroll', wheel);
        }
        window.removeEventListener('mousewheel', wheel, { passive: true });
        enable_scroll_mobile();
    }

    /*** iOS Body Scroll Lock with open menu/other modal blocks ***/

    var $docEl = $('body'),
        scrollTop;
    var overlayClose = function () {
        $.unlockBody();
    }
    var overlayOpen = function () {
        $.lockBody();
    }
    $.lockBody = function () {
        if (window.pageYOffset) {
            scrollTop = window.pageYOffset;
        }
        $docEl.css({
            height: "100%",
            overflow: "hidden"
        });
        $('html').css({
            height: "100%",
            overflow: "hidden"
        });
    }
    $.unlockBody = function () {
        $docEl.css({
            height: "",
            overflow: ""
        });
        $('html').css({
            height: "",
            overflow: ""
        });
        window.scrollTo(0, scrollTop);
        window.setTimeout(function () {
            scrollTop = null;
        }, 0);
    }

    
    /**
     * Open|Close popups
     */
    $('.wrap_container').on('click', '.open-popup', function (e) {
        e.preventDefault();
        if ($(this).hasClass('disabled')) return false;

        // if($(this).hasClass('subscribe-btn') && !$(this).closest('.subscribe-form').valid()) return false;

        var $this = $(this);
        if(!$this.hasClass('chat-item')) {
            openPopups($this);
        } else {
            if(window.innerWidth < 768) {
                openPopups($this);
            }
        }
    });

    //Close this popup with button class
    $('.wrap_popup').on('click', '.close_this_popup', function (e) {
        e.preventDefault();
        $(this).closest('.wrap_popup').find('.close').trigger('click');
    });

    function openPopups($this) {
        if($this.attr('data-popup') == 'deleteFilter' && $this.closest('.filter-block').length) { 
            $('.filter-block').removeClass('open');
        }
        if(($this.attr('data-popup') == 'moveProject' || $this.attr('data-popup') == 'beforeDeletingProject') && $this.closest('.catalog-item').length) { 
            $('#' + $this.attr('data-popup')).addClass('item_modal');
        }
        if(($this.attr('data-popup') == 'moveProject' || $this.attr('data-popup') == 'beforeDeletingProject') && $this.closest('.transfer-block').length) { 
            $('#' + $this.attr('data-popup')).addClass('multi_modal');
        }

        if($this.attr('data-popup') == 'changeProjectName' && $this.attr('data-project-name') !== undefined && $this.attr('data-project-name') !== false) {
            $('#' + $this.attr('data-popup')).find('input[name=title]').val($this.attr('data-project-name'));
            $('#' + $this.attr('data-popup')).find('input[name=id]').val($this.attr('data-project-id'));
        } else if ($this.attr('data-popup') == 'addCart' || $this.attr('data-popup') == 'addFavorite' || $this.attr('data-popup') == 'moveProject'
            || $this.attr('data-popup') == 'beforeDeleting' || $this.attr('data-popup') == 'siteTransfer' || $this.attr('data-popup') == 'deleteProject') {
            $('#' + $this.attr('data-popup')).find('input[name=new_name]').val('');
        } else if ($this.attr('data-popup') == 'withdrawPublication') {
            //null
        } else {
            $('#' + $this.attr('data-popup')).find('input[type!=hidden]').val('');
        }

        $('.overlay_page, #' + $this.attr('data-popup')).fadeIn(200);

        if (window.innerWidth < 1092) {
            overlayOpen();
        } else {
            disable_scroll();
        }

        setTimeout(function () {
            if($(window).width() > 1024) {
                $('#' + $this.attr('data-popup')).find(".modal-content").mCustomScrollbar({
                    theme: "minimal-dark",
                    autoHideScrollbar: false,
                    scrollInertia: 0
                });
            }
        }, 0);
        if($this.attr('data-popup') == 'chatRoom' || $this.attr('data-popup') == 'chatRoomSites') { 
            setTimeout(function(){
                $(".chatRoom-modal .modal-content").mCustomScrollbar("update");
                $(".chatRoom-modal .modal-content").mCustomScrollbar("scrollTo", "bottom");
            }, 0);
        }

        //Set active to first input
        setTimeout(function () {
            $('#' + $this.attr('data-popup')).find('form:not(.rent-form) input:not([type="hidden"])').first().focus();
        }, 250);
        calcSetTopHeight($('#' + $this.attr('data-popup')));
    }

    function calcSetTopHeight($el) {
        var width = $el.outerWidth() / 2,
            height = $el.outerHeight() / 2,
            windowH = $(window).height() / 2,
            windowW = $(window).width() / 2,
            top = windowH - height,
            left = windowW - width;

        if($(window).width() > 767) {
            $el.css('top', top + 'px');
            $el.css({
                'top': top + 'px',
                'left': left + 'px',
            });
        }
    }

    $('.wrap_popup').each(function () {
        var $el = $(this);
        calcSetTopHeight($el);
    });

    $('.wrap_popup .close').on('click', function (e) {
        e.preventDefault();

        if($('#beforeDeletingArticle').css('display') == 'block' && $('#publicationPopupEdit').css('display') == 'block') {
            $('#beforeDeletingArticle').fadeOut(200);
            $('.overlay_page').css('z-index', '6');
        } else {
            $('.overlay_page, .wrap_popup').fadeOut(200, function () {
                if($(window).width() > 1024) {
                    $('.modal-content').mCustomScrollbar('destroy');
                }
            });
            if($('.wrap_popup').find('form').length) {
                clearFValidate($('.wrap_popup').find('form'));
            }
            $('.wrap_popup').removeClass('item_modal').removeClass('multi_modal');

            setTimeout(function() {
                $('.beforePause-modal, .beforePlay-modal, .cancelPurchase-modal').find('.step1').show();
                $('.beforePause-modal, .beforePlay-modal, .cancelPurchase-modal').find('.step2').hide();
            }, 300);

            if (window.innerWidth < 1092) {
                overlayClose();
            } else {
                enable_scroll();
            }
        }
    });

    $('.overlay_page').on('click', function (e) {
        e.preventDefault();
        
        if($('#beforeDeletingArticle').css('display') == 'block' && $('#publicationPopupEdit').css('display') == 'block') {
            $('#beforeDeletingArticle').fadeOut(200);
            $('.overlay_page').css('z-index', '6');
        } else {
            $('.overlay_page, .wrap_popup').fadeOut(200, function () {
                if($(window).width() > 1024) {
                    $('.modal-content').mCustomScrollbar('destroy');
                }
    
                if($('.wrap_popup').find('form').length) {
                    clearFValidate($('.wrap_popup').find('form'));
                }
            });
            $('.wrap_popup').removeClass('item_modal').removeClass('multi_modal');
            
            setTimeout(function() {
                $('.beforePause-modal, .beforePlay-modal, .cancelPurchase-modal').find('.step1').show();
                $('.beforePause-modal, .beforePlay-modal, .cancelPurchase-modal').find('.step2').hide();
                $('.rejectPlacement-modal, .confirmPlacement-modal').find('.step1').show().css('display', 'flex');
                $('.rejectPlacement-modal, .confirmPlacement-modal').find('.step2').hide();
            }, 300);
            
            if (window.innerWidth < 1092) {
                overlayClose();
            } else {
                enable_scroll();
            }
        }
    });


    //Clear validate
    function clearFValidate($form) {
        $form[0].reset();
        $form.find('label.error').hide();
        $form.find('.error').removeClass('error');
        $form.find('.success').removeClass('success');
        $form.find('.drop_down').removeClass('filled');
        $form.find('.drop_down .select span').html('');
        $form.find('.drop_down .select').removeClass('text-added');
        $form.find('.drop_down .drop_down-list li').removeClass('active');
        $form.find('textarea').val('');
    }
    
    /**
     * Reset validate & data from forms
     * @param $forms
     */
    function resetForm($forms) {
        $forms.each(function () {
            $(this).validate().resetForm();
            $(this).find('input:not([readonly]):not([type="hidden"]):not([type="radio"]), textarea').val('');
            $(this).find('.success').removeClass('success');
            $(this).find('.error').removeClass('error');
        });
    }
    
    /**
     * Mobile menu and other controls
     */
    if ($(window).width() <= 1200) {
        //Open catalog
        var $btnOpen = $('.burger-btn'),
            $closeCatalog = $('.overlay_page, .nav-side .close-btn'),
            $showMenuEl = $('.nav-side');

        $btnOpen.on('click', function (e) {
            e.preventDefault();
            $showMenuEl.addClass('open');
            $('.overlay_page').fadeIn(200);

            if (window.innerWidth < 1092) {
                overlayOpen();
            } else {
                disable_scroll();
            }
        });

        $closeCatalog.on('click', function () {
            $showMenuEl.removeClass('open');
            if($('#beforeDeletingArticle').css('display') !== 'block') {
                $('.overlay_page').fadeOut(200);
            }

            if (window.innerWidth < 1092) {
                overlayClose();
            } else {
                enable_scroll();
            }
        });
    }

    // Cart modal
    
    var $btnOpenBasket = $('.basket-link'),
        $closeBasket = $('.overlay_page, .cart-modal .cancel-btn'),
        $showMenuElBasket = $('.cart-modal');

    $btnOpenBasket.on('click', function (e) {
        e.preventDefault();
        $showMenuElBasket.addClass('open');
        $('.overlay_page').fadeIn(200);

        if (window.innerWidth < 1092) {
            overlayOpen();
        } else {
            disable_scroll();
        }

        $('.save-fliter-btn').on('click', function() {
            $showMenuElBasket.removeClass('open');
        });
        $('.custom_scrollbar_y').mCustomScrollbar({
            theme: "minimal-dark",
        });
    });

    $closeBasket.on('click', function (e) {
        e.preventDefault();
        console.log(e.target)
        $showMenuElBasket.removeClass('open');

        if($('#beforeDeletingArticle').css('display') !== 'block') {
            $('.overlay_page').fadeOut(200);
        }

        if (window.innerWidth < 1092) {
            overlayClose();
        } else {
            enable_scroll();
        }
    });

    $('.cart-modal').on('click', '.close-btn', function (e) {
        e.preventDefault();
        $showMenuElBasket.removeClass('open');

        if($('#beforeDeletingArticle').css('display') !== 'block') {
            $('.overlay_page').fadeOut(200);
        }

        if (window.innerWidth < 1092) {
            overlayClose();
        } else {
            enable_scroll();
        }
    });

    $('.wrap_content').on('click', '[data-popup=publicationPopupEdit]', function() {
        $beforeDeletingArticle = $(this);
        var req = $.ajax({
            method: 'post',
            url: $beforeDeletingArticle.attr('data-action'),
            data: {'id': $beforeDeletingArticle.attr('data-id'), '_token': CSRF_TOKEN},
        });
        req.then(function(resp) {
            if (resp.success) {
                if (resp.article) {
                    var article = resp.article;
                    $('#publicationPopupEdit').find('.js-publicationPopupEdit-title').text(article.title);
                    $('#publicationPopupEdit').find('.js-publicationPopupEdit-url').text(article.url);
                    $('#publicationPopupEdit').find('.js-publicationPopupEdit-text').html(article.text);
                    if (article.meta_title) {
                        $('#publicationPopupEdit').find('.modal_title2').show();
                        $('#publicationPopupEdit').find('.js-publicationPopupEdit-meta-title-text').show();
                        $('#publicationPopupEdit').find('.js-publicationPopupEdit-meta-title').show();
                        $('#publicationPopupEdit').find('.js-publicationPopupEdit-meta-title').text(article.meta_title);
                    } else {
                        $('#publicationPopupEdit').find('.modal_title2').hide();
                        $('#publicationPopupEdit').find('.js-publicationPopupEdit-meta-title-text').hide();
                        $('#publicationPopupEdit').find('.js-publicationPopupEdit-meta-title').hide();
                    }
                    $('#publicationPopupEdit').find('.open-popup').attr('data-id', article.id);
                    if (article.edit_link) {
                        $('#publicationPopupEdit').find('.js-article-edit-button').attr('href', article.edit_link);
                    } else {
                        $('#publicationPopupEdit').find('.js-article-edit-button').attr('href', '');
                    }
                    if (article.project) {
                        $('#publicationPopupEdit').find('.js-publicationPopupEdit-project').text(article.project.title);
                    } else {
                        $('.js-publicationPopupEdit-project').text($('.js-publicationPopupEdit-project').attr('data-empty'));
                    }
                }
                openPopups($beforeDeletingArticle);
                $('[data-popup="beforeDeletingArticle"]').on('click', function() {
                    if($('#publicationPopupEdit').css('display') == 'block') {
                        $('.overlay_page').css('z-index', '8');
                    }
                });
                $('#beforeDeletingArticle').on('click', '.confirm-btn', function() {
                    var req = $.ajax({
                        method: 'post',
                        url: $('#beforeDeletingArticle').attr('data-action'),
                        data: {'id': $beforeDeletingArticle.attr('data-id'), '_token': CSRF_TOKEN},
                    });
                    req.then(function(resp) {
                        if (resp.success) {
                            $beforeDeletingArticle.closest('.control-panel_item_product').remove();
                            if (resp.text) {
                                $('.js-article-nav').text(resp.text);
                            }

                            $('.overlay_page').css('z-index' , '6');
                            $('.overlay_page, .wrap_popup').fadeOut(200, function () {
                                if($(window).width() > 1024) {
                                    $('.modal-content').mCustomScrollbar('destroy');
                                }
                            });
                            if (window.innerWidth < 1092) {
                                overlayClose();
                            } else {
                                enable_scroll();
                            }
                        }
                    });
                });
            }
        });
    });

    //copy Article
    var $publicationPopupCopy;
    $('.wrap_content').on('click', '[data-popup=publicationPopupCopy]', function() {
        $publicationPopupCopy = $(this);
        var req = $.ajax({
            method: 'post',
            url: $publicationPopupCopy.attr('data-action'),
            data: {'id': $publicationPopupCopy.attr('data-id'), '_token': CSRF_TOKEN},
        });
        req.then(function(resp) {
            if (resp.success) {
                if (resp.article) {
                    var article = resp.article;
                    $('#publicationPopupCopy').find('.js-publicationPopupCopy-title').text(article.title);
                    $('#publicationPopupCopy').find('.js-publicationPopupCopy-url').text(article.url);
                    $('#publicationPopupCopy').find('.js-publicationPopupCopy-text').html(article.text);
                    if (article.meta_title) {
                        $('#publicationPopupCopy').find('.modal_title2').show();
                        $('#publicationPopupCopy').find('.js-publicationPopupCopy-meta-title-text').show();
                        $('#publicationPopupCopy').find('.js-publicationPopupCopy-meta-title').show();
                        $('#publicationPopupCopy').find('.js-publicationPopupCopy-meta-title').text(article.meta_title);
                    } else {
                        $('#publicationPopupCopy').find('.modal_title2').hide();
                        $('#publicationPopupCopy').find('.js-publicationPopupCopy-meta-title-text').hide();
                        $('#publicationPopupCopy').find('.js-publicationPopupCopy-meta-title').hide();
                    }
                    if (article.project) {
                        $('.js-publicationPopupCopy-project').text(article.project.title);
                    } else {
                        console.log($('.js-publicationPopupCopy-project').attr('data-empty'));
                        $('.js-publicationPopupCopy-project').text($('.js-publicationPopupCopy-project').attr('data-empty'));
                    }
                }
                openPopups($publicationPopupCopy);
            }
        });
    });
    $('#publicationPopupCopy').on('click', '.save-copy', function() {
        var $this = $(this);
        var req = $.ajax({
            method: 'post',
            url: $(this).attr('data-action'),
            data: {'id': $publicationPopupCopy.attr('data-id'), '_token': CSRF_TOKEN},
        });
        req.then(function(resp) {
            if (resp.success) {
                $this.closest('.wrap_popup').find('.close').trigger('click');
                location.reload();
            }
        });
    });

    $('.wrap_content').on('click', '[data-popup=publicationPopup]', function() {
        var $publicationPopup = $(this);
        var req = $.ajax({
            method: 'post',
            url: $publicationPopup.attr('data-action'),
            data: {'id': $publicationPopup.attr('data-id'), '_token': CSRF_TOKEN},
        });
        req.then(function(resp) {
            if (resp.success) {
                if (resp.article) {
                    var article = resp.article;
                    $('#publicationPopup').find('.js-publicationPopup-title').text(article.title);
                    if (article.url) {
                        $('#publicationPopup').find('.js-publicationPopup-subtitle-url').show();
                        $('#publicationPopup').find('.js-publicationPopup-url').text(article.url).show();
                    } else {
                        $('#publicationPopup').find('.js-publicationPopup-subtitle-url').hide();
                        $('#publicationPopup').find('.js-publicationPopup-url').text('').hide();
                    }
                    if (article.text) {
                        $('#publicationPopup').find('.js-publicationPopup-subtitle-text').show();
                        $('#publicationPopup').find('.js-publicationPopup-text').html(article.text).show();
                    } else {
                        $('#publicationPopup').find('.js-publicationPopup-subtitle-text').hide();
                        $('#publicationPopup').find('.js-publicationPopup-text').html('').hide();
                    }
                    if (article.meta_title) {
                        $('#publicationPopup').find('.js-publicationPopup-subtitle-title-meta-title').show();
                        $('#publicationPopup').find('.js-publicationPopup-subtitle-meta-title').show();
                        $('#publicationPopup').find('.js-publicationPopup-meta-title').text(article.meta_title).show();
                    } else {
                        $('#publicationPopup').find('.js-publicationPopup-subtitle-title-meta-title').hide();
                        $('#publicationPopup').find('.js-publicationPopup-subtitle-meta-title').hide();
                        $('#publicationPopup').find('.js-publicationPopup-meta-title').text('').show();
                    }
                    if (article.requirements) {
                        $('#publicationPopup').find('.js-publicationPopup-subtitle-requirements').show();
                        $('#publicationPopup').find('.js-publicationPopup-requirements').html(article.requirements).show();
                    } else {
                        $('#publicationPopup').find('.js-publicationPopup-subtitle-requirements').hide();
                        $('#publicationPopup').find('.js-publicationPopup-requirements').html('').hide();
                    }

                    if (article.project) {
                        $('.js-publicationPopup-project').text(article.project.title);
                    } else {
                        $('.js-publicationPopup-project').text($('.js-publicationPopup-project').attr('data-empty'));
                    }
                }
                openPopups($publicationPopup);
            }
        });
    });

    $('.wrap_page').on('click', '[data-popup=withdrawPublication]', function() {
        var id = $(this).attr('data-id');
        $('#withdrawPublication').find('input[name=id]').val(id);
    });
    $('#withdrawPublication').on('click', '.confirm-btn', function() {
        var id = $('#withdrawPublication').find('input[name=id]').val();
        var req = $.ajax({
            method: 'post',
            url: $('#withdrawPublication').attr('data-action'),
            data: {'id': id, '_token': CSRF_TOKEN},
        });
        req.then(function(resp) {
            if (resp.success) {
                location.reload();
            } else {
                $('#withdrawPublication').find('.confirm-btn').hide();
                $('#withdrawPublication').find('.title_h1').toggle();
                setTimeout(function () {
                    $('#withdrawPublication').find('.close').click();
                    $('#withdrawPublication').find('.confirm-btn').show();
                    $('#withdrawPublication').find('.title_h1').toggle();
                }, 3000);
            }
        });
    });



    $('.wrap_content').on('click', '.control-panel_item_edit.open-popup', function() {
        $('#renameList').find('input').val($(this).closest('.control-panel_item_header').find('.project-name').text());
    });
    
    var $beforeDeletingList;
    $('.wrap_content').on('click', '.control-panel_item_delete.open-popup', function() {
        $beforeDeletingList = $(this);
        $('.confirm-btn').on('click', function() {
            if($beforeDeletingList.closest('.control-panel_item').find('.sites-item').length === 1) {
                $beforeDeletingList.closest('.control-panel_item').remove();
            }
            $beforeDeletingList.closest('.sites-item').remove();
            var newRadio = $('#beforeDeleting #project_id_new');
            var newInputText = $('#beforeDeleting input[name="new_name"]');
            if(!(newRadio.prop("checked") && newInputText.val() == "")){
              $(this).closest('.wrap_popup').find('.close').trigger('click');
            }
        });
    });

    function favoriteResponse(resp, id, del = false) {
        if (resp.success) {
            if($('.catalog-item[data-id='+id+']').find('.js-favorite-button').hasClass('open-popup')){
                $('#addFavorite').find('.close').trigger('click');
            }
            if (resp.button) {
                $('.catalog-item[data-id='+id+']').find('.js-favorite-button').replaceWith(resp.button);
                $('.product-content--right[data-id='+id+']').find('.js-favorite-button').replaceWith(resp.button);
            }
            if (resp.header_link) {
                $('.header-link-item.favorite-link').html(resp.header_link);
            }
            if (resp.modal) {
                $('#addFavorite .modal-content').replaceWith(resp.modal);
            }
            if (resp.moveProject) {
                $('#moveProject .modal-content').replaceWith(resp.moveProject);
            }
            if (resp.nav_side) {
                $('.nav-side .js-nav-side-favorite').html(resp.nav_side);
            }
            if (resp.text) {
                $('.js-favorite-nav').text(resp.text);
            }
        }
    }
    function deleteFromFavorite(id, url) {
        var req = $.ajax({
            method: 'post',
            url: url,
            data: {'id': id, '_token': CSRF_TOKEN},
        });
        req.then(function(resp) {
            favoriteResponse(resp, id, true);
        });
    }

    function removeFavorite(ids, cid, name, url) {
        var req = $.ajax({
            method: 'post',
            url: url,
            data: {'ids': ids, 'name':name, 'cid': cid, '_token': CSRF_TOKEN},
        });
        req.then(function(resp) {
            if (resp.success) {
                location.reload();
            }
        });
    }

    var $beforeDeletingProject,
        closestItem;
    $('.wrap_content').on('click', '[data-popup="beforeDeletingProject"], [data-popup="moveProject"]', function() {
        $beforeDeletingProject = $(this);
        $('#beforeDeletingProject, #moveProject').on('click', '.confirm-btn', function() {
            if($(this).closest('#moveProject').length && $(this).closest('.modal-content').find('.radio-new-name input').is(':checked') && $(this).closest('.modal-content').find('.for-new-name input').val().length) {
                var url = $beforeDeletingProject.attr('data-action');
                var cid = $('#moveProject').find('input[name=favorite_category_id]:checked').val();
                var name = $('#moveProject').find('input[name=new_name]').val();
                $('#moveProject').find('.confirm-btn').attr('disabled', true);
                if($beforeDeletingProject.closest('.catalog-item').length) {
                    $beforeDeletingProject.closest('.catalog-item').slideUp(200, function() {
                        closestItem = $(this).closest('.control-panel_item');
                        var id = $(this).attr('data-id');
                        removeFavorite([id], cid, name, url);
                        $(this).remove();
                        calcPlatformItems(closestItem);
                    });
                    $(this).closest('.wrap_popup').find('.close').trigger('click');
                    if($beforeDeletingProject.closest('.control-panel_item').find('.catalog-item.selected').length <= 1) {
                        $beforeDeletingProject.closest('.control-panel_item').find('.transfer-block').slideUp(200);
                    }
                }
                else if($beforeDeletingProject.closest('.transfer-block').length) {
                    var ids = [];
                    $beforeDeletingProject.closest('.control-panel_item').find('.catalog-item.selected').each(function( index ) {
                        ids.push($(this).attr('data-id'));
                    });
                    $beforeDeletingProject.closest('.control-panel_item').find('.catalog-item.selected').slideUp(200, function() {
                        closestItem = $(this).closest('.control-panel_item');
                        $(this).remove();
                    });
                    $beforeDeletingProject.closest('.control-panel_item').find('.transfer-block').slideUp(200);
                    $(this).closest('.wrap_popup').find('.close').trigger('click');
                    removeFavorite(ids, cid, name, url);
                    calcPlatformItems(closestItem);
                }
                $('#moveProject').find('.confirm-btn').attr('disabled', false);
            }
            else if(!$(this).closest('#moveProject').length || !$(this).closest('.modal-content').find('.radio-new-name input').is(':checked')) {
                var self = this;
                if($beforeDeletingProject.closest('.catalog-item').length) {
                    $beforeDeletingProject.closest('.catalog-item').slideUp(200, function() {
                        closestItem = $(this).closest('.control-panel_item');
                        var id = $(this).attr('data-id');
                        var url = $beforeDeletingProject.attr('data-action');
                        if ($(self).closest('#moveProject').length) {
                            var cid = $('#moveProject').find('input[name=favorite_category_id]:checked').val();
                            var name = $('#moveProject').find('input[name=new_name]').val();
                            removeFavorite([id], cid, name, url);
                        } else {
                            deleteFromFavorite(id, url);
                        }
                        $(this).remove();
                        calcPlatformItems(closestItem);
                    });
                    $(this).closest('.wrap_popup').find('.close').trigger('click');
                    if($beforeDeletingProject.closest('.control-panel_item').find('.catalog-item.selected').length <= 1) {
                        $beforeDeletingProject.closest('.control-panel_item').find('.transfer-block').slideUp(200);
                    }
                }
                else if($beforeDeletingProject.closest('.transfer-block').length) {
                    var ids = [];
                    $beforeDeletingProject.closest('.control-panel_item').find('.catalog-item.selected').each(function( index ) {
                        ids.push($(this).attr('data-id'));
                    });
                    $beforeDeletingProject.closest('.control-panel_item').find('.catalog-item.selected').slideUp(200, function() {
                        closestItem = $(this).closest('.control-panel_item');
                        var id = $(this).attr('data-id');
                        var url = $beforeDeletingProject.attr('data-action');
                        if ($(self).closest('#moveProject').length) {
                            var cid = $('#moveProject').find('input[name=favorite_category_id]:checked').val();
                            var name = $('#moveProject').find('input[name=new_name]').val();
                            removeFavorite(ids, cid, name, url);
                        } else {
                            deleteFromFavorite(id, url);
                        }
                        $(this).remove();
                        calcPlatformItems(closestItem);
                    });
                    $beforeDeletingProject.closest('.control-panel_item').find('.transfer-block').slideUp(200);
                    $(this).closest('.wrap_popup').find('.close').trigger('click');
                }
            } else {
                $(this).closest('.modal-content').find('.for-new-name label').show();
            }
        });
    });

    //favorite
    $('body').on('click', '.js-favorite-button', function (e) {
        e.preventDefault();
        var id = $(this).attr('data-id');
        if ($(this).hasClass('open-popup')) {
            $('#addFavorite input[name="id"]').val(id);
        } else {
            var url = $(this).attr('data-action');
            deleteFromFavorite(id, url);
        }
    });
    $('#addFavorite').on('click', 'a.confirm-btn', function(e) {
        e.preventDefault();
        if ($('#addFavorite #fav_catnew').is(':checked')) {
            if ($('.for-new-name input').val().trim() == '') {
                $('.for-new-name .error').show();
                return false;
            }
        };
        var id = $('#addFavorite').find('input[name=id]').val();
        var name = $('#addFavorite').find('input[name=new_name]').val();
        var c_id = $('#addFavorite').find('input[name=add_favorite_category_id]:checked').val();

        var req = $.ajax({
            method: 'post',
            url: $(this).attr('data-action'),
            data: {'id': id, 'name':name, 'c_id': c_id, '_token': CSRF_TOKEN},
        });
        req.then(function(resp) {
            favoriteResponse(resp, id, false);
        });
    });
    $('body').on('click', '[data-popup="renameList"]', function () {
        var id = $(this).attr('data-id');
        $('#renameList input[name="id"]').val(id);
    });
    $('body').on('click', '[data-popup="beforeDeletingList"]', function () {
        var title = $(this).attr('data-title');
        var id = $(this).attr('data-id');
        $('#beforeDeletingList .title_h3 b').text(title);
        $('#beforeDeletingList .confirm-btn').attr('data-id', id);
    });
    $('#beforeDeletingList').on('click', 'a.confirm-btn', function(e) {
        e.preventDefault();
        var id = $(this).attr('data-id');

        var req = $.ajax({
            method: 'post',
            url: $(this).attr('data-action'),
            data: {'id': id, '_token': CSRF_TOKEN},
        });
        req.then(function(resp) {
            if (resp.success) {
                $('.control-panel_item[data-id='+id+']').remove();
                favoriteResponse(resp, 0);
                if ($('.control-panel_item').length < 2) {
                    $('.control-panel_item').show();
                }
            }
        });
    });

    // Form validate

    function changeProjectName(form) {
        var url = $(form).attr('action');
        var data = $(form).serialize();
        var req = $.ajax({
            method: 'post',
            url: url,
            data: data
        });
        req.then(function(resp) {
            if (resp.success) {
                if (resp.html) {
                    $('.js-index-insert').html(resp.html);
                    $(form).closest('.wrap_popup').find('.close').trigger('click');
                }
                if (! $('.js-index-insert').length) {
                    location.reload();
                }
            } else {
                var errors = $.parseJSON(resp.errors);
                $.each(errors, function(key, value) {
                    $(form).find('input[name='+key+']').addClass('error');
                    $(form).find('input[name='+key+']').after('<label id="'+key+'-error" class="error" for="'+key+'">'+value+'</label>');
                });
            }
        })
    }

    
    $.validator.addMethod("notOnlyZero", function (value, element, param) {
        return this.optional(element) || parseInt(value) > 0;
    });
    $.validator.methods.email = function (value, element) {
        return this.optional(element) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(punycode.toUnicode(value));
    };
    /**
     * Form validate
     */
    $('form.validate').each(function () {
        $(this).validate({
            highlight: function (element) {
                $(element).addClass("error").removeClass("success");
            },
            unhighlight: function (element) {
                $(element).removeClass("error").addClass("success");
                $(element).siblings('.error').remove();
            },
            ignore: ':hidden:not(.validate)',
            rules: {
                password_confirmation: {
                    equalTo: ".password_first"
                },
                numeric: {
                    notOnlyZero: '0'
                },
                amount: {
                    notOnlyZero: '0'
                },
                url: {
                  url: true
                }
            },
            focusInvalid: false,
            invalidHandler: function(form, validator) {

                if (!validator.numberOfInvalids())
                    return;
                if(!$(validator.errorList[0].element).closest('.wrap_popup').length) {
                    if($(validator.errorList[0].element).attr('type') === 'hidden' && $(validator.errorList[0].element).closest('.form-group').length) {
                        $('html, body').animate({
                            scrollTop: $(validator.errorList[0].element).closest('.form-group').offset().top - 120
                        }, 500);
                    } else {
                        $('html, body').animate({
                            scrollTop: $(validator.errorList[0].element).offset().top - 120
                        }, 500);
                    }
                    $(validator.errorList[0].element).focus();
                }
            },
            //Send form
            submitHandler: function (form) {
                console.log('Form send');
                if($(form).attr('id') == 'change-project-name') {
                    changeProjectName(form);
                }
                if($(form).attr('id') == 'login-form' || $(form).attr('id') == 'recovery-pass-form' || $(form).attr('id') == 'createNewListForm') {
                    $(form).unbind().submit();
                }
                if($(form).attr('id') == 'confirmPlacement-form') {
                   $(form).closest('.modal-content').find('.step1').hide();
                   $(form).closest('.modal-content').find('.step2').fadeIn(100).css('display', 'flex');
                }
                if($(form).attr('id') == 'for-email-form') {
                    openPopups($(form).find('button'));
                }

                if($(form).attr('id') == 'registration-form' || $(form).attr('id') == 'recovery-form') {
                    $(form).find('[type=submit]').attr('disabled', true);
                    var url = $(form).attr('action');
                    var data = $(form).serializeArray();
                    var purpose = null;
                    if ($(form).attr('id') == 'registration-form') {
                        purpose = $(form).find('input[name=purpose]:checked').val();
                    }
                    var req = $.ajax({
                        method: 'post',
                        url: url,
                        data: data
                    });
                    req.done(function(resp) {
                        if (resp.success) {
                            // datalayer
                            if (purpose && purpose == 'advertiser') {
                                dataLayer.push({'event':'registration_advertiser'});
                            } else if (purpose && purpose == 'platform') {
                                dataLayer.push({'event':'registration_platform'});
                            }

                            $('.base-content').find('.step-1').hide();
                            $('.base-content').find('.step-2').fadeIn(100);
                        }
                        $(form).find('[type=submit]').attr('disabled', false);
                    })
                    req.fail(function(error) {
                        var errors = $.parseJSON(error.responseText);
                        $.each(errors.errors, function(key, value) {
                            $(form).find('input[name='+key+']').addClass('error');
                            $(form).find('input[name='+key+']').after('<label id="'+key+'-error" class="error" for="'+key+'">'+value+'</label>');
                        });
                        $(form).find('[type=submit]').attr('disabled', false);
                    });
                }
            }
        });
    });

    
    $('#registration-form').each(function () {
        $(this).validate({
            highlight: function (element) {
                $(element).addClass("error").removeClass("success");
            },
            unhighlight: function (element) {
                $(element).removeClass("error").addClass("success");
                $(element).siblings('.error').remove();
            },
            errorPlacement: function(error, element) {
                if($(element).attr('name') == 'subjects[]') {
                    var lastEl = $('.for-purposeP').find('.checkbox-group:last-child').find('input')
                    error.insertAfter(lastEl);
                }
            },
            ignore: '',
            rules: {
                password_confirmation: {
                    equalTo: ".password_first"
                },
            },
            focusInvalid: false,
            invalidHandler: function(form, validator) {

                if (!validator.numberOfInvalids())
                    return;

                $('html, body').animate({
                    scrollTop: $(validator.errorList[0].element).offset().top - 40
                }, 500);
                $(validator.errorList[0].element).focus();
            },
            //Send form
            submitHandler: function (form) {
                console.log('Form send');
                if($(form).attr('id') == 'change-project-name') {
                    changeProjectName(form);
                }
                if($(form).attr('id') == 'login-form' || $(form).attr('id') == 'recovery-pass-form' || $(form).attr('id') == 'createNewListForm') {
                    $(form).unbind().submit();
                }
                if($(form).attr('id') == 'confirmPlacement-form') {
                   $(form).closest('.modal-content').find('.step1').hide();
                   $(form).closest('.modal-content').find('.step2').fadeIn(100).css('display', 'flex');
                }
                if($(form).attr('id') == 'for-email-form') {
                    openPopups($(form).find('button'));
                }
                if($(form).attr('id') == 'registration-form' || $(form).attr('id') == 'recovery-form') {
                    $(form).find('[type=submit]').attr('disabled', true);
                    var url = $(form).attr('action');
                    var data = $(form).serialize();
                    var req = $.ajax({
                        method: 'post',
                        url: url,
                        data: data
                    });
                    req.done(function(resp) {
                        if (resp.success) {
                            $('.base-content').find('.step-1').hide();
                            $('.base-content').find('.step-2').fadeIn(100);
                        }
                        $(form).find('[type=submit]').attr('disabled', false);
                    })
                    req.fail(function(error) {
                        var errors = $.parseJSON(error.responseText);
                        $.each(errors.errors, function(key, value) {
                            $(form).find('input[name='+key+']').addClass('error');
                            $(form).find('input[name='+key+']').after('<label id="'+key+'-error" class="error" for="'+key+'">'+value+'</label>');
                        });
                        $(form).find('[type=submit]').attr('disabled', false);
                    });
                }
            }
        });
    });

    $('form#profile-form').each(function () {
        $(this).validate({
            highlight: function (element) {
                $(element).addClass("error").removeClass("success");
            },
            unhighlight: function (element) {
                $(element).removeClass("error").addClass("success");
            },
            ignore: ':hidden:not(.validate)',
            rules: {
                password_confirmation: {
                    equalTo: ".password_first"
                },
            },
            focusInvalid: false,
            invalidHandler: function(form, validator) {

                if (!validator.numberOfInvalids())
                    return;

                $('html, body').animate({
                    scrollTop: $(validator.errorList[0].element).offset().top - 40
                }, 500);
                $(validator.errorList[0].element).focus();
            },
            //Send form
            submitHandler: function (form) {
                var url = $(form).attr('action');
                var data = $(form).serialize();
                var req = $.ajax({
                    method: 'post',
                    url: url,
                    data: data
                });
                req.done(function(resp) {
                    if (resp.success) {
                        $(form).find('[name=password_old]').val('');
                        $(form).find('[name=password]').val('');
                        $(form).find('[name=password_confirmation]').val('');
                    }
                })
                req.fail(function(error) {
                    var errors = $.parseJSON(error.responseText);
                    $.each(errors.errors, function(key, value) {
                        $(form).find('input[name='+key+']').addClass('error');
                        $(form).find('input[name='+key+']').after('<label id="'+key+'-error" class="error" for="'+key+'">'+value+'</label>');
                    });
                    $(form).find('[type=submit]').attr('disabled', false);
                })
                req.always(function () {
                    //password_confirmation
                });
            }
        });
    });

    $('form.validate-rename-list').each(function () {
        $(this).validate({
            highlight: function (element) {
                $(element).addClass("error").removeClass("success");
            },
            unhighlight: function (element) {
                $(element).removeClass("error").addClass("success");
            },
            onfocusout: function(element) {
                if (element.name != "title")
                    this.element(element);
            },
            ignore: '',
            //Send form
            submitHandler: function (form) {
                $(form).find('[type=submit]').attr('disabled', true);
                var id = $(form).find('input[name=id]').val();
                var title = $(form).find('input[name=title]').val();
                var url = $(form).attr('action');

                var req = $.ajax({
                    method: 'post',
                    url: url,
                    data: {'id': id, 'title':title, '_token': CSRF_TOKEN},
                });
                req.then(function(resp) {
                    if (resp.success) {
                        if (resp.title) {
                            $('.project-name[data-id='+id+']').text(resp.title);
                        }
                        $(form).closest('.wrap_popup').find('.close').trigger('click');
                    }
                    $(form).find('[type=submit]').attr('disabled', false);
                });
            }
        });
    });

    $('.wrap_content').on('click', '[data-popup=beforePause], [data-popup=cancelPurchase], [data-popup=beforePlay]', function () {
        var popup = $(this).attr('data-popup');
        var id = $(this).attr('data-id');
        var status = $(this).attr('data-status');
        $('#'+popup).attr('data-id', id);
        $('#'+popup).attr('data-status', status);
    });

    $('.cancelPurchase-modal').on('click', '.confirm-btn', function(e) {
        e.preventDefault();
        var $this = $(this);
        var url = $('.cancelPurchase-modal').attr('data-action')
        var id = $('.cancelPurchase-modal').attr('data-id')
        var req = $.ajax({
            method: 'post',
            url: url,
            data: {'id': id, '_token': CSRF_TOKEN},
        });
        req.then(function(resp) {
            if (resp.success) {
                $this.closest('.step1').hide();
                $('.control-panel_item_product[data-id='+id+']').remove();
                $this.closest('.modal-content').find('.step2').fadeIn(100, function() {
                    calcSetTopHeight($(this).closest('.wrap_popup'));
                });
            }
        });
    });

    $('.wrap_content').on('click', '[data-popup=cancelPurchaseArchive1]', function () {
        var popup = $(this).attr('data-popup');
        var id = $(this).attr('data-id');
        $('#'+popup).attr('data-id', id);
    });

    $('#cancelPurchaseArchive1').on('click', '.confirm-btn', function(e) {
        e.preventDefault();
        var $this = $(this);
        var url = $('#cancelPurchaseArchive1').attr('data-action')
        var id = $('#cancelPurchaseArchive1').attr('data-id')
        var req = $.ajax({
            method: 'post',
            url: url,
            data: {'id': id, '_token': CSRF_TOKEN},
        });
        req.then(function(resp) {
            location.reload();
        });
    });

    $('.wrap_content').on('click', '[data-popup=restoreArchive]', function () {
        var popup = $(this).attr('data-popup');
        var id = $(this).attr('data-id');
        $('#'+popup).attr('data-id', id);
    });

    $('#restoreArchive').on('click', '.confirm-btn', function(e) {
        e.preventDefault();
        var $this = $(this);
        var url = $('#restoreArchive').attr('data-action')
        var id = $('#restoreArchive').attr('data-id')
        var req = $.ajax({
            method: 'post',
            url: url,
            data: {'id': id, '_token': CSRF_TOKEN},
        });
        req.then(function(resp) {
            location.reload();
        });
    });

    $('.beforePause-modal, .beforePlay-modal').on('click', '.confirm-btn', function(e) {
        e.preventDefault();
        var $this = $(this);
        var url = $(this).closest('.wrap_popup').attr('data-action');
        var id = $(this).closest('.wrap_popup').attr('data-id');
        var status = $(this).closest('.wrap_popup').attr('data-status');
        var req = $.ajax({
            method: 'post',
            url: url,
            data: {'id': id, 'status':status, '_token': CSRF_TOKEN},
        });
        req.then(function(resp) {
            if (resp.success) {
                if (resp.href) {
                    location.href = resp.href;
                }
                // $this.closest('.step1').hide();
                // $this.closest('.modal-content').find('.step2').fadeIn(100, function() {
                //     calcSetTopHeight($(this).closest('.wrap_popup'));
                // });
            }
        });
    });

    $('.wrap_content').on('click', '[data-popup=rejectPlacement], [data-popup=confirmPlacement]', function () {
        var popup = $(this).attr('data-popup');
        var id = $(this).attr('data-id');
        var service_id = $(this).attr('data-service_id');
        $('#'+popup).find('input[name=id]').val(id);
        $('#'+popup).find('.js-service-confirm').hide();
        $('#'+popup).find('.js-service-confirm-group').hide();
        service_id = service_id.split(',');
        if (service_id.length && service_id[0].length > 0) {
            service_id.forEach(function (elem) {
                $('#'+popup).find('.js-service-confirm[data-service_id='+elem+']').show();
            })
            $('#'+popup).find('.js-service-confirm-group').show();
            $('#confirmPlacement').removeClass('w-328').addClass('w-1105');
        } else {
            $('#confirmPlacement').addClass('w-328').removeClass('w-1105');
        }
    });

    $('.rejectPlacement-modal, .confirmPlacement-modal').on('click', '.confirm-btn', function(e) {
        e.preventDefault();
        if (!window.FormData) {
            console.error('Browser not support FormData');
            return;
        }
        var $this = $(this);
        var form = $(this).closest('form');
        console.log($(this.form));
        $this.attr('disabled', true);
        var action = $(form).attr('action');
        var data = new FormData(this.form);
        $this.closest('form').find('label.error').remove();
        var req = $.ajax({
            method: 'post',
            url: action,
            data: data,
            contentType: false,
            processData: false,
        });
        req.done(function(resp) {
            if (resp.success) {
                if (resp.href) {
                    location.href = resp.href;
                }
                if (resp.reload) {
                    location.reload();
                }
            }
        })
        req.fail(function(error) {
            var errors = $.parseJSON(error.responseText);
            $.each(errors.errors, function(key, value) {
                $this.closest('form').find('input[name="'+key+'"]').addClass('error');
                $this.closest('form').find('input[name="'+key+'"]').after('<label id="'+key+'-error" class="error" for="'+key+'">'+value+'</label>');
                $this.closest('form').find('input[data-name="'+key+'"]').addClass('error');
                $this.closest('form').find('input[data-name="'+key+'"]').after('<label id="'+key+'-error" class="error" for="'+key+'">'+value+'</label>');
            });
        })
        req.always(function () {
            $this.attr('disabled', false);
        });
    });



    $('.js-payment-refill').on('click', function () {
        var alias = $(this).attr('data-alias');
        var form = $(this).closest('form');
        if(form.valid()) {
            form.find('input[name=alias]').val(alias);
            form.unbind().submit();
        }
    });
    $('.js-payment-withdrawal').on('click', function () {
        var alias = $(this).attr('data-alias');
        var form = $(this).closest('form');
        form.find('input[name=alias]').val(alias);
        var url = form.attr('action');
        var data = form.serialize();
        if(form.valid()) {
            form.find('[type=submit]').attr('disabled', true);
            var req = $.ajax({
                method: 'post',
                url: url,
                data: data
            });
            req.done(function(resp) {
                if (resp.success) {
                    form.find('input[name!=_token]').val('');
                    openPopups(form.find('button'));
                }
                if (resp.reject) {
                    form.find('input[name!=_token]').val('');
                    openPopups(form.find('.rejectReplenishment'));
                }
            })
            req.fail(function(error) {
                var errors = $.parseJSON(error.responseText);
                $.each(errors.errors, function(key, value) {
                    form.find('input[name='+key+']').addClass('error');
                    form.find('input[name='+key+']').after('<label id="'+key+'-error" class="error" for="'+key+'">'+value+'</label>');
                });

            })
            req.always(function () {
                form.find('[type=submit]').attr('disabled', false);
            });
        }
    });
    $('.js-balance-content').on('click', '.pagination li', function (e) {
        e.preventDefault();
        var url = $(this).attr('data-url');
        var title = $('head title').text();
        var req = $.ajax({
            method: 'get',
            url: url,
        });
        req.then(function(resp) {
            if (resp.success) {
                if (resp.html) {
                    $('.js-balance-content .js-payments-table').replaceWith(resp.html);
                    if (resp.pager) {
                        $('.js-balance-content .pager').replaceWith(resp.pager);
                    }
                }
                history.pushState({}, title, url);
            }
        });
    });

    var platformItemCount;
    function calcPlatformItems(item) {
        platformItemCount = item.find('.control-panel_body .catalog-item').length;
        item.find('.project-number b').html(platformItemCount);
        if(platformItemCount === 0 && item.hasClass('without-folder')) {
            item.remove();
        }
    }
    $('.control-panel_item').each(function() {
        calcPlatformItems($(this));
    });


    function deskHeader(){
        if($(window).scrollTop() > 100){
            $('.big-header').addClass('showed');
        } else {
            $('.big-header').removeClass('showed');
            $('.header_user_block').hide();
        }
    }

    if ($(window).width() >= 1200) {
        $(window).on('scroll', function() {
            deskHeader();
        });
        deskHeader();
    }
    if ($(window).width() < 768) {
        $(window).on('scroll', function() {
            if($(window).scrollTop() > 16){
                $('.content-header').addClass('scroll');
            } else {
                $('.content-header').removeClass('scroll');
            }
        });
        if($(window).scrollTop() > 16){
            $('.content-header').addClass('scroll');
        } else {
            $('.content-header').removeClass('scroll');
        }
    }
    $(document).on('click', '.cookie-accept-js', function (e) {
        e.preventDefault();
        var url = $(this).attr('data-url');
        $.post(url, {agree: true, '_token': CSRF_TOKEN})
        .done(function( data ) {
            $('.cookie-info').fadeOut(200);
        });
    });
});
